import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import ErrorBoundary from './components/layout/ErrorBoundary'
import ScrollToTop from './components/layout/ScrollToTop'
import Home from './pages/Home'
import Practice from './pages/Practice'
import About from './pages/About'
import ReadingLevel from './pages/ReadingLevel'
import NotFound from './pages/NotFound'
import { useTheme } from './hooks/useTheme'

function App() {
  // Initialize theme on app load
  useTheme()

  return (
    <ErrorBoundary>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/index.html" element={<Navigate to="/" replace />} />
          <Route path="/practice" element={<Practice />} />
          <Route path="/practice.html" element={<Navigate to="/practice" replace />} />
          <Route path="/about" element={<About />} />
          <Route path="/about.html" element={<Navigate to="/about" replace />} />

          {/* Dynamic reading level routes */}
          <Route path="/countdown" element={<ReadingLevel />} />
          <Route path="/countdown.html" element={<Navigate to="/countdown" replace />} />
          <Route path="/blastoff" element={<ReadingLevel />} />
          <Route path="/blastoff.html" element={<Navigate to="/blastoff" replace />} />
          <Route path="/space" element={<ReadingLevel />} />
          <Route path="/space.html" element={<Navigate to="/space" replace />} />
          <Route path="/moon" element={<ReadingLevel />} />
          <Route path="/moon.html" element={<Navigate to="/moon" replace />} />
          <Route path="/mars" element={<ReadingLevel />} />
          <Route path="/mars.html" element={<Navigate to="/mars" replace />} />

          {/* 404 catch-all route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  )
}

export default App
